import React from 'react';

import PropTypes from 'prop-types';

import CardPeacock from './PeacockCheckoutCard';
import CardCheckout from './CheckoutCard';
import './CheckoutConfirmedForm.scss';

function CheckoutConfirmedForm({
  selectedCard,
  values,
  devicePrice,
  devicePriceFee,
  shippingPriceFee,
  renderButtons,
  showFireCode,
}) {
  const Card = showFireCode ? CardPeacock : CardCheckout;
  return (
    <div id="checkoutConfirmedForm">
      <div className="main_container grid">
        <div className="data_container col-7">
          <div className="grid">
            <div className="col-12 flex align-items-center header">
              <div className="header_number">5</div>
              <div className="header_text_box">
                <p className="step_text_mobile">Step 5 of 5</p>
                <h2 className="header_title">Confirm Order</h2>
              </div>
            </div>
            <div className="form_conatiner">
              <div className="sub-header col-12">
                <p className="sub_header_text">Please verify your information to confirm your order.</p>
              </div>
              <div className="col-12">
                <div className="values_conatiner flex flex-column">
                  <div className="col-12 align-items-center justify-content-between flex">
                    <h4>Contact Information</h4>
                  </div>
                  <div className="values_box col-6">
                    <div className="value_item">
                      <label>{values.firstName}</label>
                    </div>
                    <div className="value_item">
                      <label>{values.role}</label>
                    </div>
                    <div className="value_item">
                      <label>{values.phone}</label>
                    </div>
                    <div className="value_item">
                      <label>{values.businessEmail}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="values_conatiner flex flex-column">
                  <div className="col-12 align-items-center justify-content-between flex">
                    <h4>Business Information</h4>
                  </div>
                  <div className="values_box col-6">
                    <div className="value_item">
                      <label>{values.businessName}</label>
                    </div>
                    {values.fireCode ? (
                      <div className="value_item">
                        <label>FCO: {values.fireCode}</label>
                      </div>
                    ) : (
                      <div className="value_item">
                        <label>{values.industry}</label>
                      </div>
                    )}
                    <div className="value_item">
                      <label>
                        {values.businessAddress} {values.businessAddress2}, {values.city}, {values.country}, {values.zipCode}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="values_conatiner flex flex-column">
                  <div className="col-12 align-items-center justify-content-between flex">
                    <h4>Billing Information</h4>
                  </div>
                  <div className="values_box col-6">
                    <div className="value_item">
                      <label>
                        {values.billingAddress} {values.billingAddress2}, {values.billingCity}, {values.billingCountry},{' '}
                        {values.billingZipCode}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="values_conatiner flex flex-column">
                  <div className="col-12 align-items-center justify-content-between flex">
                    <h4>Shipping Information</h4>
                  </div>
                  <div className="values_box col-6">
                    <div className="value_item">
                      <label>
                        {values.shippingBusinessAddress} {values.shippingBusinessAddress2}, {values.shippingCity},{' '}
                        {values.shippingCountry}, {values.shippingZipCode}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {renderButtons()}
            </div>
          </div>
        </div>
        <div className="card_container col-5 align-self-start">
          <Card
            id={selectedCard?.id}
            title={selectedCard?.title}
            price={selectedCard?.priceText}
            checkList={selectedCard?.checklistP}
            icon={selectedCard?.icon}
            devicePrice={devicePrice}
            numberOfDevices={values.numberOfDevices}
            devicePriceFee={devicePriceFee}
            shippingPriceFee={shippingPriceFee}
            showFireCode
            peacockFee={values.fireCodePrice}
            billingPlan={values.billingPlan}
          />
        </div>
      </div>
    </div>
  );
}

CheckoutConfirmedForm.propTypes = {
  values: PropTypes.shape({
    shippingBusinessAddress: PropTypes.string.isRequired,
    shippingBusinessAddress2: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    businessEmail: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    businessName: PropTypes.string.isRequired,
    industry: PropTypes.string.isRequired,
    fireCode: PropTypes.number.isRequired,
    businessAddress: PropTypes.string,
    businessAddress2: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    zipCode: PropTypes.string,
    billingAddress: PropTypes.string.isRequired,
    billingAddress2: PropTypes.string.isRequired,
    billingCity: PropTypes.string.isRequired,
    billingCountry: PropTypes.string.isRequired,
    billingZipCode: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    shippingCity: PropTypes.string.isRequired,
    shippingCountry: PropTypes.string.isRequired,
    shippingZipCode: PropTypes.string.isRequired,
    numberOfDevices: PropTypes.number.isRequired,
    fireCodePrice: PropTypes.number,
    billingPlan: PropTypes.string,
  }).isRequired,
  devicePrice: PropTypes.number,
  devicePriceFee: PropTypes.number,
  shippingPriceFee: PropTypes.number,
  selectedCard: PropTypes.objectOf(PropTypes.any),
  renderButtons: PropTypes.any,
  showFireCode: PropTypes.bool,
};

CheckoutConfirmedForm.defaultProps = {
  devicePrice: undefined,
  devicePriceFee: undefined,
  shippingPriceFee: undefined,
  selectedCard: undefined,
  renderButtons: () => {},
  showFireCode: false,
};

export default CheckoutConfirmedForm;
